export default __webpack_public_path__ + "static/media/t2.ae8791c8.png";